import 'css/mobile/post-comments.scss';

import 'js/mobile/common/common.jquery';

import 'js/plugin/jquery-facebook-sdk/facebook-sdk.jquery.js';
import 'js/plugin/jquery-facebook-sdk/facebook-comments.jquery.js';
// import 'js/plugin/disqus-comments.js';
import 'js/plugin/jquery-featured-post/featured-post.jquery.js';

/**
 * Load and initializes the Facebook SDK.
 */
$(document).fbSDK()
  .on('fbSDK:load', function () {
    if ($(document).data('plugin_fbSDK').options.appId) {
      $('.fb-comments').fbComments({ disableScroll: true });
    }
  });

$(document).ready(function () {
  /**
   * Load fetured post
   */
  $('#featured-now').featuredPost();
});
